import React, { useState, useEffect } from "react";
import { Typography, Button, Modal, Form, Col, Row, Input, Select, DatePicker, InputNumber } from "antd";
import SectionHeading from "./section-headings";
import { EditOutlined, ExclamationCircleFilled } from "@ant-design/icons"
import { useRecoilValue, useSetRecoilState, useRecoilState } from "recoil";

import { orgmode, showloader, productSelection, checkFilledDirector, directorsData, inwardPartner, hasInwardBank, orgaDetails, newPartnerList } from "../../store/gloabalState";
import config from '../../config/form.json';
import DirectorFileComponent from "../onboarding/directorFileComponent";
import { CountryCode, dinRegex, emailRegex, phoneRegex } from "../../config/globalVar";
import DirectorCard from "./director-card";
import dayjs from 'dayjs';
import useNotify from "../../utils/useNotify"
import { getDirectors, putDirectorDetails } from "../../services/httpCalls"
import Cookies from "js-cookie";
import { getDirectorsProbe } from "../../utils/onboarding/director-details/get-directors-probe";
import { editDirectorRequest } from "../../utils/onboarding/director-details/edit-director";
import { submitDirector } from "../../utils/onboarding/director-details/submit-director";
import { getProductionSelectionType, showField, NEW_REFACTOR} from "../../utils/onboarding/onboardingUtils";

const Directors = () => {

  // initializing form
  const [form] = Form.useForm();

  // getting directors config data;
  const configData = config.directorDetails[0].directors[0];

  // local states
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [directorsID, setDirectorsID] = useState([]);
  const [recheckDocs, setRecheckDocs] = useState(false);
  const [editDirector, setEditDirector] = useState(false);
  const [docsDirectors, setDocsDirector] = useState([]);
  const [editAddressNull, setEditAddressNull] = useState("");
  const [directorsDocsPAN, setDirectorsDocsPAN] = useState([]);
  const [refreshDirectors, setRefreshDirectors] = useState(false);
  const [directorsDocsAADHAR, setDirectorsDocsAADHAR] = useState([]);
  const [directorsDocsPASSPORT, setDirectorsDocsPASSPORT] = useState([]);
  const [checknationalityIndian, setCheckIndianNationality] = useState(true);
  const inwardPartnerState = useRecoilValue(inwardPartner);


  // global states

  // values
  const mode = useRecoilValue(orgmode)
  const partnerState = useRecoilValue(inwardPartner)
  const hasInwardBankValue = useRecoilValue(hasInwardBank);
  const partnerListState = useRecoilValue(newPartnerList);
  const orgDetails = useRecoilValue(orgaDetails)

  // updater/setter
  const setShowLoader = useSetRecoilState(showloader)

  // states
  const [directors, setDirectors] = useRecoilState(directorsData);
  const [validateDir, setValidateDir] = useRecoilState(checkFilledDirector);
  const selectionValue = useRecoilValue(productSelection);

  // constants/binders
   const {hasOnlyPartners, hasOnlyPayglocal, hasOnlyXflow, hasOnlyInwardBank} = getProductionSelectionType(selectionValue,partnerState, hasInwardBankValue);
  let directors_ = [];
  let postDataArray = [];
  let notify = useNotify();
  const { confirm } = Modal;
  const dateFormat = "DD/MM/YYYY";
  const emailRegexRef = emailRegex;
  const dinRegexRef = dinRegex;
  const phoneRegexRef = phoneRegex;
  const CountryCodeInstance = CountryCode;
  const dayjsInstance = dayjs;
  const directorsShouldRender = !hasInwardBankValue && partnerState.length > 0 && ["SOLE_PRORIETOR", "FREELANCER"].includes(orgDetails?.companyType)

    const deleteDirector = elem => {
        setShowLoader(true)
        let data = {
          status: "DELETED"
        }
        let orgId = localStorage.getItem("orgId")
        if (elem?.id !== undefined && elem?.id !== null) {
          putDirectorDetails(orgId, elem.id, data)
            .then(res => {
              if (res !== undefined) {
                if (res.length === 0) {
                  setDirectors([])
                }
                notify.success("Director Deleted!")
              } else {
                notify.error("Error deleting Director!")
              }
            })
            .catch(() => {
              notify.error("Error deleting Director!")
            })
            .finally(() => {
              setShowLoader(false)
              setRefreshDirectors(!refreshDirectors)
            })
        } else {
          notify.error("Not able to find director with the correct ID!")
        }
      }

  const showDeleteConfirm = (elem, val) => {
    confirm({
      title: (
        <p>
          We require information about all the directors, are you sure you want
          to delete this director? <br /> <b>{elem?.name}</b>
        </p>
      ),
      icon: <ExclamationCircleFilled />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => deleteDirector(elem)
    })
  }

  // get data from probe
  const getDirectorsFromProbe = async () => {
    await getDirectorsProbe({
      notify,
      Cookies,
      directors_,
      setShowLoader,
      postDataArray,
      setDirectors,
      refreshDirectors,
      setRefreshDirectors
    })
  }

  // function to edit director
  const editDirectorFun = async (elem) => {
    await editDirectorRequest({
      elem,
      form,
      dayjs,
      setEditId,
      dateFormat,
      setRecheckDocs,
      recheckDocs,
      setDocsDirector,
      setCheckIndianNationality,
      setEditAddressNull,
      setEditDirector,
      setOpen
    })
  }

  const getAllDirectors = async () => {
    let orgId = localStorage.getItem("orgId")
    await getDirectors(orgId)
      .then(res => {
        if (res !== undefined) {
          if (res?.length) {
            setDirectors(res)
            localStorage.setItem("directors_", JSON.stringify(res))
          } else {
            if (directors?.length === 0 && res?.length === 0) {
              getDirectorsFromProbe()
            }
          }
        }
      })
      .catch(err => notify.error("Not able to get directors data!"))
      .finally(() => setShowLoader(false))
  }


  useEffect(() => {
    !directorsShouldRender && getAllDirectors()
  }, [refreshDirectors])

  // * prefilling data
  useEffect(() => {
    const checkDirectorsDataFilled = async () => {
      let orgId = localStorage.getItem("orgId")
      await getDirectors(orgId).then(res => {
        if (res !== undefined) {
          if (res.length) {
            let formFilled = false
            let filledID = []
            res.forEach(val => {
              if (selectionValue === "inward") {
                if (inwardPartnerState.includes("payglocal")) {
                  
                  if (
                    val?.name !== null &&
                    val?.panNumber !== null &&
                    val?.emailId !== null &&
                    val?.dob !== null &&
                    val?.phoneNumber !== null &&
                    val?.docs !== null
                  ) {
                    formFilled = true
                    filledID.push(val?.id)
                  }
                } else {
                  if (
                    val?.name !== null &&
                    val?.panNumber !== null &&
                    val?.nationality !== null
                  ) {
                    formFilled = true
                    filledID.push(val?.id)
                  }
                }

              } else {
                if (
                  val?.name !== null &&
                  val?.dateOfAppointment !== null &&
                  val?.din !== null &&
                  val?.emailId !== null &&
                  val?.panNumber !== null &&
                  val?.nationality !== null &&
                  val?.address &&
                  val?.docs !== null
                ) {
                  formFilled = true
                  filledID.push(val?.id)
                } else {
                  formFilled = false
                }
              }
            })
            setValidateDir(formFilled)
            setDirectorsID(filledID)
          }
        }
      })
    }
    checkDirectorsDataFilled()
  }, [validateDir, refreshDirectors])

  const addNewDirector = async () => {
    form.resetFields()
    setEditDirector(false)
    setOpen(true)
    setRecheckDocs(!recheckDocs)
    setCheckIndianNationality(true)
    setDocsDirector([])
    setDirectorsDocsAADHAR([])
    setDirectorsDocsPASSPORT([])
    setDirectorsDocsPAN([])
  }

  const handleCancel = () => {
    setCheckIndianNationality(true)
    setDocsDirector([])
    setDirectorsDocsAADHAR([])
    setDirectorsDocsPASSPORT([])
    setDirectorsDocsPAN([])
    setEditDirector(false)
    setOpen(false)
    form.resetFields()
  }

  const handleFinish = async (values) => {
    await submitDirector({
      values,
      setShowLoader,
      editDirector,
      selectionValue,
      checknationalityIndian,
      directorsDocsPAN,
      directorsDocsPASSPORT,
      directorsDocsAADHAR,
      editId,
      setRefreshDirectors,
      setOpen,
      refreshDirectors,
      form,
      setDirectorsDocsPAN,
      setDirectorsDocsAADHAR,
      setDirectorsDocsPASSPORT,
      setDocsDirector,
      notify,
      setRefresh
    })
  };

  // cleaning up states on unmount of component.
  useEffect(() => {
    return ()=>{
      setDirectors([])
    }
  },[])

  const handleValueChange = (value) => {
    if (value?.nationality === "Indian") {
      setCheckIndianNationality(true);
    } else if (value?.nationality === "Foreigner") {
      setCheckIndianNationality(false);
    }
  }

  const renderField = (field, index) => {
    const { type, label, name, props, style, tooltip } = field

    // * formatting rules
    field?.rules?.forEach(item => {
      if (item?.pattern) {
        item.pattern = eval(item?.pattern);
      }
      if (item?.required) {
        item.required = eval(item?.required)
      }
      if (item?.validator) {
        item.validator = eval(item?.validator)
      }
    });

    switch (type) {
      case 'Form.Item':
        return (
          <React.Fragment>
            <Form.Item
              label={label}
              name={name}
              rules={field?.rules}
              tooltip={tooltip}
              labelCol={field?.labelCol}
              required={eval(field?.required)}
            >
              {field?.children ? renderField(field?.children, 0) : null}
            </Form.Item>
            {field?.subFields ? field?.subFields.map((child, childIndex) => renderField(child, childIndex)) : null}
          </React.Fragment>
        )
      case 'Input':
        return (
          <Input
            disabled={eval(props?.disabled)}
            readOnly={eval(props?.readOnly)}
            name={field?.name}
            onKeyUp={eval(props?.onKeyUp)}
            maxLength={field?.maxLength}
          />
        );
      case 'Button':
        return (
          <Button
            type={type}
            style={style}
            onClick={eval(props.onClick)}
            disabled={eval(props.disabled)}
          >
            {eval(label)}
          </Button>
        )
      case 'Select':
        return (
          <Select
            options={eval(field?.options)}
            readOnly={eval(props?.readOnly)}
            disabled={eval(props?.disabled)}
            showSearch={props?.showSearch}
            allowClear={props?.allowClear}
            default={field?.default}
            filterOption={eval(props?.filterOption)}
            onKeyUp={eval(props?.onKeyUp)}
            optionFilterProp={props?.optionFilterProp}
            placeholder={field?.placeholder}
          />
        )
      case 'DatePicker':
        return (
          <DatePicker
            format={eval(props?.dateFormat)}
            disabledDate={eval(props?.disabledDate)}
            style={field?.style}
          />
        );
      case 'InputNumber':
        return (
          <InputNumber
            style={style}
            type={props.type}
            controls={field?.controls}
            onKeyUp={eval(props?.onKeyUp)}
            readOnly={eval(props?.readOnly)}
          />
        )
      case 'SectionHeading':
        return (
          <SectionHeading
            style={field?.style}
            level={field?.level}
            heading={field?.heading}
            Col={field?.Col}
          />
        )
      case 'DirectorFileComponent':
        return (
          <DirectorFileComponent
            name={name}
            form={form}
            type={field?.subType}
            setDirectorsDocsPASSPORT={eval(props?.setDirectorsDocsPASSPORT)}
            setDirectorsDocsAADHAR={eval(props?.setDirectorsDocsAADHAR)}
            setDirectorsDocsPAN={eval(props?.setDirectorsDocsPAN)}
            docsDirectors={eval(props?.docsDirectors)}
            recheckDocs={eval(props?.recheckDocs)}
            editDirector={eval(props?.editDirector)}
            selectionValue={eval(props?.selectionValue)}
          />
        )
      default:
        return null;
    }

  }

  return (
    <>
    {directorsShouldRender ?
      <></>:<>
            <div>
        <Typography.Title level={4}>List of Directors</Typography.Title>
        <Typography.Text>
          Please enter the details for the directors of the company, you can
          fill details by clicking on <EditOutlined /> in directors card
        </Typography.Text>
      </div>
      <div
        style={{
          padding: "0px",
          margin: ".5rem 0"
        }}
      >
        <Button type="primary"
          onClick={() => addNewDirector()}
          disabled={mode === 'view' ? true : false}
        >
          Add Directors
        </Button>
      </div>
      <DirectorCard
        directors={directors}
        selectionValue={selectionValue}
        mode={mode}
        directorsID={directorsID}
        showDeleteConfirm={showDeleteConfirm}
        editDirectorFun={editDirectorFun}
      />
      </>
    }
      <Modal
        open={open}
        onCancel={handleCancel}
        width={800}
        style={{ top: 20 }}
        footer={null}
      >
        <div
            style={{
                display:"flex",
                alignItems:"baseline"
            }}
        >
            <div
              style={{
                background: "#2863FE",
                height: "15px",
                width: "3px",
                borderRadius: "5px",
                marginRight: "5px"
              }}
            ></div>
                <Form
                {...configData.formConfig}
                form={form}
                onFinish={handleFinish}
                onValuesChange={handleValueChange}
                disabled={mode === 'view'}
            >
                <Row gutter={[16,16]}>
                {configData.fields.map((field, index) => {

                const checkNaitonalityBoolean = field?.checkNationality ? checknationalityIndian ? field?.checkNationality === "Indian" : field?.checkNationality === "Foreigner" : true;

                const isVisible = showField(field.productList , partnerListState) && checkNaitonalityBoolean ;

                const isRefactoredRender = isVisible;

                // conditional render
                return isRefactoredRender && (
                  <Col key={index} span={field?.Col ? field.Col : 12}>
                    {renderField(field, index)}
                  </Col>
                )
              })}
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "16px"
              }}
            >
              <Button
                onClick={() => {
                  setOpen(false)
                  setCheckIndianNationality(true)
                  setDocsDirector([])
                  setDirectorsDocsAADHAR([])
                  setDirectorsDocsPASSPORT([])
                  setDirectorsDocsPAN([])
                  setEditDirector(false)
                  form.resetFields()
                }}
                style={{ marginRight: "1rem" }}
              >
                Cancel
              </Button>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </div>
          </Form>
        </div>
      </Modal>
    </>
  )

}

export default Directors;